import gql from 'graphql-tag';

import homeRowFragment from '../fragments/homeRowFragment';

export const queryHomeRows = gql`
  query homeRows(
    $count: Int
  ) {
    homeRows(
      count: $count
    ) {
      ...homeRowFragment
    }
  }
  ${homeRowFragment}
`;
export default queryHomeRows;
